import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/api';
import { Cep } from 'src/app/admihair/api/dto/cep';
import { Cliente } from 'src/app/admihair/api/dto/cliente';
import { ContatoCliente } from 'src/app/admihair/api/dto/contato-cliente';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { ExceptionDto } from 'src/app/admihair/api/dto/exception/exception-dto';
import { IndicadorCliente } from 'src/app/admihair/api/dto/indicador-cliente';
import { Municipio } from 'src/app/admihair/api/dto/municipio';
import { Uf } from 'src/app/admihair/api/dto/uf';
import { CepService } from 'src/app/admihair/service/cep.service';
import { ClienteService } from 'src/app/admihair/service/cliente.service';
import { ContatoClienteService } from 'src/app/admihair/service/contato-cliente.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { IndicadorClienteService } from 'src/app/admihair/service/indicador-cliente.service';
import { MunicipioService } from 'src/app/admihair/service/municipio.service';
import { UfService } from 'src/app/admihair/service/uf.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';
import { FormatacaoUtil } from 'src/app/admihair/util/formatacao-util';
import { ValidacaoUtil } from 'src/app/admihair/util/validacao-util';
import { AdmihairBaseComponent } from '../../../admihair-base.component';

@Component({
  selector: 'app-cliente-inserir',
  templateUrl: './cliente-inserir.component.html',
  styleUrls: ['./cliente-inserir.component.scss']
})
export class ClienteInserirComponent extends AdmihairBaseComponent implements OnInit {

  listaUfs: Uf[] = [];
  ufSelecionado?: Uf;
  isUfSelecionada: boolean = false;
  listaMunicipios: Municipio[] = [];
  municipioSelecionado?: Municipio;
  indicadoresClientes: IndicadorCliente[] = [];
  indicadorSelecionado: any;
  empresaSelecionada?: Empresa;
  temDuasPalavras: boolean = false;
  contaPrincipal: boolean = true;
  erroSalvarContato: boolean = false;
  contatoCliente: ContatoCliente = { principal: true };
  listaContatos: ContatoCliente[] = [];
  enderecoCep: Cep = { endereco: ' ', bairro: ' ' };
  date?: Date;
  exibirMensagemCep: boolean = false;
  bloquearCamposEndereco: boolean = true;
  trocarCamposEndereco: boolean = false;
  modoEdicaoLogradouro: boolean = false;
  modoEdicaoBairro: boolean = false;
  clienteCpfEncontrado: boolean = false;
  bloqueiaNumeroEComplemento: boolean = true;
  focoCampo: boolean = false;
  dataValida?: boolean = true;
  progressoRequisicao: boolean = false;

  cliente: Cliente = {
    nome: '',
    apelido: '',
    cpf: '',
    cep: '',
    logradouro: '',
    bairro: '',
    numeroEndereco: '',
    complementoEndereco: '',
    cidade: '',
    uf: '',
    email: '',
    status: true,
    excluido: false,
    indicadorCliente: ''

  }

  constructor(private clienteService: ClienteService,
    private utilStorageService: UtilStorageService,
    private indicadorClienteService: IndicadorClienteService,
    private contatoClienteService: ContatoClienteService,
    private municipioService: MunicipioService,
    private ufService: UfService,
    private cepService: CepService,
    erroService: ErroService,
    storageService: UtilStorageService,) {

      super(erroService, storageService)
     }

  @ViewChild('f') form?: NgForm;
  value?: string;

  ngOnInit(): void {
    this.permissaoInserir = this.permissaoDetalhar = this.verificarPermissao('PERM_INSERIR_CLIENTE');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    this.listarIndicadoresClientesPorEmpresa(this.empresaSelecionada.id);
    this.listarUfs();
    this.modoEdicaoLogradouro = false;
    this.modoEdicaoBairro = false;
  }

  salvar() {
    this.progressoRequisicao = true;

    this.cliente.empresa = this.empresaSelecionada;
    this.cliente.nome = FormatacaoUtil.removerCaracteresEspeciais(this.cliente.nome);
    this.cliente.apelido = FormatacaoUtil.removerCaracteresEspeciais(this.cliente.apelido);
    this.cliente.aniversario = this.fomatarAniversario(this.cliente.aniversario?.toString());

    this.cliente.logradouro = FormatacaoUtil.removerCaracteresEspeciais(this.cliente.logradouro);
    this.cliente.bairro = FormatacaoUtil.removerCaracteresEspeciais(this.cliente.numeroEndereco);
    this.cliente.complementoEndereco = FormatacaoUtil.removerCaracteresEspeciais(this.cliente.complementoEndereco);
    this.cliente.cidade = FormatacaoUtil.removerCaracteresEspeciais(this.cliente.cidade);

    // if(this.trocarCamposEndereco){
    //   this.cliente.uf = this.enderecoCep.estado;
    //   cliente.cidade = FormatacaoUtil.removerCaracteresEspeciais(this.enderecoCep.cidade);
    // } else {
    //   cliente.uf = this.ufSelecionado?.siglaUf;
    //   cliente.cidade = FormatacaoUtil.removerCaracteresEspeciais(this.municipioSelecionado?.descricao);
    //   const cepDigitado: Cep = {
    //     cep: cliente.cep,
    //     endereco: cliente.logradouro,
    //     bairro: cliente.bairro,
    //     cidade: cliente.cidade,
    //     estado: cliente.uf
    //   }
    //   this.salvarCep(cepDigitado);
    // }
    // cliente.logradouro = FormatacaoUtil.removerCaracteresEspeciais(this.enderecoCep.endereco);
    // cliente.bairro = FormatacaoUtil.removerCaracteresEspeciais(this.enderecoCep.bairro);
    // cliente.complementoEndereco = FormatacaoUtil.removerCaracteresEspeciais(cliente.complementoEndereco);


    // if(!this.enderecoPresente(cliente)){
    //   cliente.uf = this.empresaSelecionada?.uf;
    //   cliente.cidade = this.empresaSelecionada?.cidade;
    // }
    // FormatacaoUtil.removerCaracteresEspeciais(cliente.apelido) : this.formatarApelido(cliente.nome);

    this.clienteService.salvar(this.cliente).subscribe({
      next: (data: Cliente) => {
        if (this.listaContatos.length > 0) {
          this.salvarContatoCliente(data.id);
        }
        this.progressoRequisicao = false;
        this.exibirMensagemSucesso();
        this.limparFormulario();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.exibirMensagemErro(err);

      }
    }
    );
  }

  listarIndicadoresClientesPorEmpresa(empresaId?: number) {
    this.indicadorClienteService.listarIndicadoresClientesPorEmpresa(empresaId).subscribe(
      (data) => {
        this.indicadoresClientes = data;
      },
      (error) => {
        this.exibirMensagemErro(error);
      }
    );
  }

  listarUfs() {
    this.ufService.listarUf().subscribe({
      next: (data: Uf[]) => {
        this.listaUfs = data;
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    }
    )

    const fusoHorarioNavegador = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  listarMunicipios() {
    if (this.ufSelecionado !== undefined && this.ufSelecionado !== null) {
      this.isUfSelecionada = true;
      this.municipioService.listarMuniciosPorUf(this.ufSelecionado.codigoUf).subscribe({
        next: (data: Municipio[]) => {
          this.listaMunicipios = data;
        },
        error: (err: any) => {

        }
      }
      )
    }

  }

  salvarContatoCliente(clienteId?: number) {
    for (const contato of this.listaContatos) {
      const cliente: Cliente = {};
      cliente.id = clienteId;
      contato.cliente = cliente;
      this.contatoClienteService.salvar(contato).subscribe({
        next: (data: ContatoCliente) => {
        },
        error: (err: any) => {
          this.progressoRequisicao = false;
          this.exibirMensagemErro(err);
        }
      }
      )
    }
  }


  consultarCep() {
    var cep = this.cliente.cep;
    if (cep !== '' && cep !== undefined) {
      this.cepService.buscarPorCodigo(cep).subscribe({
        next: (data: Cep) => {
          this.enderecoCep = data;
          if (!this.enderecoCep.endereco) {
            this.modoEdicaoLogradouro = true;
            this.exibirMensagemCep = true;
          } else {
            this.modoEdicaoLogradouro = false;
            this.cliente.logradouro = data.endereco;
            this.exibirMensagemCep = false;
          }
          if (!this.enderecoCep.bairro) {
            this.modoEdicaoBairro = true;
            this.exibirMensagemCep = true;
          } else {
            this.modoEdicaoBairro = false;
            this.cliente.bairro = data.bairro;
            this.exibirMensagemCep = false;
          }
          this.cliente.uf = data.estado;
          this.cliente.cidade = data.cidade;
          this.trocarCamposEndereco = true;
          this.bloquearCamposEndereco = true;
          this.bloqueiaNumeroEComplemento = false;
        },
        error: (err: any) => {
          this.enderecoCep = { endereco: ' ', bairro: ' ' };
          this.exibirMensagemCep = true;
          this.trocarCamposEndereco = false;
          this.bloquearCamposEndereco = false;
          this.modoEdicaoLogradouro = true;
          this.modoEdicaoBairro = true;
          this.bloqueiaNumeroEComplemento = false;
          this.focoCampo = true;


        }
      });
    } else {
      this.bloqueiaNumeroEComplemento = true;
    }
  }

  salvarCep(cep: Cep) {

    this.cepService.salvar(cep).subscribe({
      next: (data: Cep) => {
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    });
  }

  buscarClientePorCpf() {
    const cpf = this.form?.value.cpf;

    if (cpf && cpf.length === 11) {
      this.clienteService.buscarClientePorEmpresaECpf(this.empresaSelecionada?.id, cpf).subscribe({
        next: () => {
          this.clienteCpfEncontrado = true;
        },
        error: (err: any) => {
          this.clienteCpfEncontrado = false;

        }
      });
    } else {
      this.clienteCpfEncontrado = false;
    }

  }

  liberaCampo(item: string): boolean {
    return item ? true : false;
  }
  camposPreenchendo() {
    this.exibirMensagemCep = false;
  }

  enderecoPresente(cliente: Cliente): boolean {
    return !!cliente.uf &&
      !!cliente.cidade;
  }



  adicionarContato() {
    if (this.validarContatoCliente()) {
      this.listaContatos.push(this.contatoCliente);
      this.contatoCliente = { principal: false };
    }
  }

  validarContatoCliente(): boolean {
    return this.contatoCliente.numero !== undefined &&
      this.contatoCliente.numero.length === 14;
  }
  removerContato(contato: ContatoCliente) {
    const posicao = this.listaContatos.indexOf(contato);
    this.listaContatos.splice(posicao, 1);
  }

  editarContato(contato: ContatoCliente) {
    this.contatoCliente = contato;
    this.removerContato(contato);
  }

  mostrarBotoes(): boolean {
    return Object.keys(this.contatoCliente).length > 1;
  }

  formatarApelido(nome?: string): string {
    return nome !== undefined ? nome.split(' ')[0] : '';
  }

  tratarErroApi(exceptions: ExceptionDto[]) {
    if (exceptions.length > 0) {
      this.messages = [{ severity: 'error', summary: exceptions[0].requestId, detail: exceptions[0].data[0].message }];
    }
  }
  ocultarMensagem() {
    if (this.messagemVisivel) {
      this.messagemVisivel = false;
    }
  }

  limparFormulario() {
    this.form?.reset();
    this.listaContatos = [];
    this.isUfSelecionada = false;
  }

  ocultarMsg() {
    this.messagemVisivel = false;
  }

  validarNome(event: any) {
    this.temDuasPalavras = ValidacaoUtil.validarMultiplasPalavras(event);
  }

  validarAniversario() {
    const aniversario = this.form?.value.aniversario;
    if (!aniversario) {
      return;
    }
    const [dia, mes] = aniversario.split('/').map(Number);
    if (isNaN(dia) || isNaN(mes)) {
      return;
    }
    const diasPorMes = [0, 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    this.dataValida = (mes >= 1 && mes <= 12) &&
      (dia >= 1 && dia <= diasPorMes[mes]);
  }

  fomatarAniversario(aniversario?: string): Date | undefined {
    if (aniversario !== '' && aniversario !== undefined) {
      const [day, month] = aniversario?.split('/');
      const dataFormatada = new Date(new Date().getFullYear(), Number(month) - 1, Number(day));
      return new Date(dataFormatada);
    }
    return undefined;
  }
}
